/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import {
  mapGetters
} from 'vuex';
export default {
  name: 'interview-reschedule',
  components: {
    datetime: Datetime,
  },
  props: [],
  data () {
    return {
      submitted:false,
      interview_date:'',
      reason:'',
      interviewInfo:null,
      minDatetime:new Date().toISOString()
    }
  },
  computed: {
    ...mapGetters([
      'interviewInfoByIdGetters'
    ]),
    getInterviewInfoByIdFun() {
      this.interviewInfo = this.$store.getters.interviewInfoByIdGetters.data
      return
    },
    setIntialStates(){
      if(this.interviewInfo){
        this.interview_date = this.interviewInfo.interview_date
      }
      return
    }
  },
  mounted () {
    this.getInterviewInfoByIdFun
    this.setIntialStates
  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          var formData = new FormData();
          formData.append('interview_date', this.interview_date);
          formData.append('reason', this.reason);
          formData.append('rescheduled', true);
          this.$store.dispatch('updateInterviewInfoByIDFun', { data:{ data:formData, id: this.$route.params.rescheduledInterviewID}})
            .then((res) => {  
              toast.success(res.data.msg);      
              this.submitted = false;      
              this.$router.push({ name: 'employeeList'})
              // this.$router.push({ name: 'employeeInterviewList'})
            }).catch((err) => {     
              this.submitted = false;  
              toast.error(err.data.user_msg || err.data.msg);
            })
            return;
        }
      });
    },
  },
  watch:{
    getInterviewInfoByIdFun() {
      return this.$store.getters.interviewInfoByIdGetters
    },
    setIntialStates(){
      if(this.interviewInfo){
        this.interview_date = this.interviewInfo.interview_date
      }
      return
    }
  }
}